import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RouterBreadcrumbService } from './router-breadcrumb.service';

@NgModule({
  imports: [CommonModule]
})
export class RouterBreadcrumbModule {
  constructor(breadcrumbService: RouterBreadcrumbService) {
    /* intentionally left blank */
  }
}

export * from './router-breadcrumb.service';
